import React from 'react';
import * as PropTypes from 'prop-types';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import theme from '../../theme';
import { shouldForwardProp } from '../../lib/utils';

const StyleAndThemeProvider = ({ children }) => {
    return (
        <StyleSheetManager shouldForwardProp={shouldForwardProp}>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
        </StyleSheetManager>
    );
};

StyleAndThemeProvider.propTypes = {
    children: PropTypes.node,
};

export default StyleAndThemeProvider;
